import React from "react";
import {withStyles} from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const Reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export const CustomCheckbox = withStyles({
    root: {
        color: "#CCCCCC",
        "&$checked": {
            color: "#306F9D",
        },
        padding: "6px"
    },
    checked: {},
})(
    React.forwardRef((props, ref) => (
        <Checkbox color="default" {...props} ref={ref}/>
    ))
);

export const PaginationIconButton = withStyles({
    root: {
        border: "1px solid #CCCCCC",
        borderRadius: "3px 0 0 3px",
        padding: "2px",
        color: "#CCCCCC",
        background: "#FFFFFF",
        "&.right": {
            borderRadius: "0 3px 3px 0",
        },
    },
})((props) => <IconButton color="default" {...props} />);

export const getPageable = (page = 0, offset = 0, pageSize = 10) => {
    return `?page=${page}&offset=${offset}&size=${pageSize}&unpaged=true`;
};

export const getKeyword = (queryString) => {
    return queryString && queryString !== "" ? `&keyword=${queryString}` : "";
};

export const modal = Swal.mixin({
    customClass: {
        container: "popUpContainer",
        popup: "popUpClass",
        header: "popUpHeader",
        title: "popUpTitle",
        closeButton: "popUpCloseButton",
        icon: "popUpIcon",
        content: "popUpContent",
        actions: "popUpActions",
        confirmButton: "popUpConfirmButton",
        cancelButton: "popUpCancelButton",
        footer: "popUpFooter",
    },
    reverseButtons: true,
});

export const checkExtIsImg = (url) => {
    const imgExt = ['.png', '.jpeg', '.jpg', '.avif', '.gif', '.svg', '.webp'];
    try {
        return imgExt.some(ext => url.toLowerCase().endsWith(ext));
    } catch (error) {
        console.log(error);
        return false;
    }
}

export const openLinkWithState = (history, pathname, state, event) => {
    history.push({
        pathname,
        state
    })
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    return false;
}

export const formatDatetime = (dt, format = "DD MMM YYYY HH:mm") => {
    return dayjs(dt).format(format);
};

export const formatDateTimeWithTz = (dt, format = "YYYY-MM-DDTHH:mm:ss") => {
    return dayjs.tz(dt, "Asia/Hong_Kong").format(format);
}